$(document).on('turbolinks:load', function(){
    $('.link').on('click', function(e){
      e.stopPropagation();
    //  e.preventDefault();
    });
});
